// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Slider from "@material-ui/lab/Slider";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Chip from "@material-ui/core/Chip";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { StyledTextFieldClassesType } from "./StyledTextField";
import { InputStyles } from "./StyledTextField";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...InputStyles(theme),
  sliderRoot: {
    padding: 0,
    marginBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 6
  },
  chip: {
    marginLeft: "5px",
    marginTop: "30px"
  },
  content: {
    display: "flex"
  }
});

type StyledSliderFieldPropsType = {
  classes: {
    ...StyledTextFieldClassesType,
    sliderRoot: DictionaryType,
    chip: DictionaryType,
    content: DictionaryType
  },
  label: string,
  name: string,
  value: number,
  min?: number,
  max?: number,
  step?: number,
  display?: string,
  onChange: Function,
  isRequired?: boolean,
  isInvalid?: boolean,
  isDisabled?: boolean
};

class StyledSlider extends Component<StyledSliderFieldPropsType, {}> {
  handleChange = (event: SyntheticInputEvent<*>, value: number) => {
    this.props.onChange(this.props.name, value);
  };

  render(): React$Element<*> {
    const classes = this.props.classes;

    return (
      <FormControl fullWidth={true} disabled={this.props.isDisabled}>
        {this.props.label !== "" && (
          <InputLabel
            htmlFor={this.props.name}
            required={this.props.isRequired}
            error={this.props.isInvalid}
            shrink={true}
            classes={{
              root: classes.greenLabel,
              formControl: classes.textFieldFormLabel,
              focused: classes.labelFocused,
              error: classes.labelError,
              disabled: classes.labelDisabled
            }}
          >
            {this.props.label}
          </InputLabel>
        )}
        <div className={classes.content}>
          <Slider
            classes={{
              root: classes.sliderRoot
            }}
            value={this.props.value}
            aria-labelledby={"slider-" + this.props.name}
            component="span"
            disabled={this.props.isDisabled}
            onChange={this.handleChange}
            min={this.props.min || 0}
            max={this.props.max || 100}
            step={this.props.step || 1}
          />
          {this.props.display && (
            <Chip
              label={this.props.display}
              className={classes.chip}
              color="primary"
            />
          )}
        </div>
      </FormControl>
    );
  }
}

export default withStyles(styles)(StyledSlider);
